import { createActionCreators } from './optionsBase';
import { isCensusView } from '../selectors/router';

export const SELECT_CITIES = 'SELECT_CITIES';
export const SELECT_CENSUS_TRACTS = 'SELECT_CENSUS_TRACTS';
export const SET_COMP_CHART_TYPE = 'SET_COMP_CHART_TYPE';
export const SET_SORTING = 'SET_SORTING';
export const SET_SORT_PAGE = 'SET_SORT_PAGE';

export const selectLocations = (selected, subset) => (dispatch, getState) =>
  dispatch({
    type: isCensusView(getState()) ? SELECT_CENSUS_TRACTS : SELECT_CITIES,
    payload: { selected, subset },
  });

export const setSorting = (sortColumn, sortReversed) => ({
  type: SET_SORTING,
  payload: { sortColumn, sortReversed },
});

export const setSortPage = sortPage => ({
  type: SET_SORT_PAGE,
  payload: sortPage,
});

export const setCompChartType = val => ({
  type: SET_COMP_CHART_TYPE,
  payload: val,
});

export const prefix = 'OPTIONS';

export const actions = createActionCreators(prefix);

export const types = {
  SELECT_CITIES,
  SELECT_CENSUS_TRACTS,
  SET_SORTING,
  SET_SORT_PAGE,
  SET_COMP_CHART_TYPE,
};



// WEBPACK FOOTER //
// ./src/actions/options.js